module.exports = __webpack_public_path__ + "media/king.8165dd96.mp3";